import Stack from "@mui/material/Stack";
import HelpAndShare from "components/LayoutFront/HelpAndShare";
import Wrapper from "components/LayoutFront/Wrapper";
import PropTypes from "prop-types";
import React from "react";

const Standard = (props) => {
  const { page } = props;
  const { title, contents, template } = page;
  const { dynamicPart } = contents;

  return (
    <Wrapper sx={{ px: { xs: 2, lg: 0 } }}>
      <Stack>
        <h1>{title}</h1>
        {dynamicPart}
      </Stack>
      <HelpAndShare template={template} alwaysDisplayShare mt={7} />
    </Wrapper>
  );
};

Standard.propTypes = {
  page: PropTypes.shape().isRequired,
};

export default Standard;
